import { assets, assetsHasErrored, assetsIsLoading, assetsIsLoaded, preloadingDone } from './reducers/assets';
import { combineReducers } from 'redux';

export default combineReducers({
	assets,
	assetsHasErrored,
	assetsIsLoading,
	assetsIsLoaded,
	preloadingDone,
});



// WEBPACK FOOTER //
// ./src/reducer.js